import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { environment } from "../../../environments/environment";

export interface ExamenMedicoRecord {
  id?: number;
  nombre?: string;
  descripcion?: string | null;
  estado?: number;
  fecha_creacion?: Date | string;
  fecha_modificacion?: Date | string;
  usuario_creacion?: number | null;
  usuario_modificacion?: number | null;

  // ✅ Campos del formulario de examen médico
  cedula?: number | string;
  tipo_examen?: number;
  fecha_realizo?: string;
  fecha_vencimiento?: string;
  entidad?: number | string;

  // ✅ Exámenes realizados anidados
  examenes_realizados?: {
    examen: number;
    realizo: number | null;
    descripcion?: string | null;
  }[];
}
@Injectable({
  providedIn: "root",
})
export class ExamenesMedicosService {
  private apiUrl = `${environment.apiUrl}/api/examenes_medicos`;

  constructor(private http: HttpClient) {}

  getExamenesMedicos(): Observable<any> {
    return this.http
      .get<any>(this.apiUrl, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getExamenesMedicosByEstado(estado: number | string): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/estado/${estado}`, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  getExamenMedicoById(id: number | string): Observable<any> {
    return this.http
      .get<any>(`${this.apiUrl}/${id}`, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  createExamenMedico(payload: ExamenMedicoRecord): Observable<any> {
    return this.http
      .post<any>(this.apiUrl, payload, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  updateExamenMedico(
    id: number | string,
    payload: ExamenMedicoRecord,
  ): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}`, payload, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

  deleteExamenMedico(id: number | string): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`, {
        withCredentials: true,
      })
      .pipe(catchError((error) => throwError(() => error)));
  }

    getExamenesMedicosByCedula(cedula: string): Observable<any[]> {
      return this.http.get<any[]>(`${this.apiUrl}/cedula/${cedula}`, { withCredentials: true })
        .pipe(catchError((error) => throwError(() => error)));
    }

    

  inactivarExamenesMedicos(id: number): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/inactivar`, { estado: 0 }, { withCredentials: true }).pipe(catchError((error) => throwError(() => error)));
  }
}
